import React, { Suspense } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import {
  CContainer,
  CSpinner,
  CImage,
  CHeader,
  CHeaderNav,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CNavLink,
  CNavItem,
} from '@coreui/react-pro'

// routes config
import siteRoutes from '../siteRoutes'

const styles = {
  miFooter: {
    fontFamily: 'Gotham, sans-serif',
    padding: '4rem 0',
    background: 'linear-gradient(to right, #0063BA, #4B035C)',
    color: '#FFF',
  },
  miFooterH6: {
    fontFamily: 'Gotham, sans-serif',
    fontSize: '12pt',
    marginBottom: '0.2rem',
    color: '#FFF',
  },
  miFooterUL: {
    fontFamily: 'Gotham, sans-serif',
    fontSize: '16pt',
    color: '#FFF',
    listStyleImage: 'none',
    listStylePosition: 'inside',
    listStyleType: 'none',
    marginInlineStart: '0px',
    marginInlineEnd: '0px',
    padding: '0px'
  },
  miFooterLI: {
    fontFamily: 'Gotham, sans-serif',
    fontSize: '12pt',
    color: '#FFF',
    lineHeight: '16pt',
    listStyleImage: 'none',
    listStylePosition: 'inside',
    listStyleType: 'none',
    marginLeft: '0px',
    marginInlineStart: '0px'
  },
  miFooterLI2: {
    fontFamily: 'Gotham, sans-serif',
    fontSize: '12pt',
    color: '#FFF',
    lineHeight: '16pt',
    listStyleImage: 'none',
    listStylePosition: 'inside',
    listStyleType: 'none',
    paddingLeft: '30px',
    paddingRight: '30px',
  },
  miFooterA: {
    fontFamily: 'Gotham, sans-serif',
    fontSize: '10pt',
    color: '#FFF',
    textDecoration: 'none'
  },
}

const SiteLayout = () => {
  const navigate = useNavigate();

  const followLink = (url) => {
    navigate(url);
  }

  return (
    <>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
        <CHeader position="sticky">
          <CContainer fluid>
            <CHeaderNav className="d-none d-md-flex me-auto">
              <CNavItem>
                <CNavLink href="" onClick={(e) => { e.preventDefault(); followLink("/"); }}>
                  <CImage src="https://miinews.com/static/core/graphics/mii-logo-final.svg" width="50" className="me-2" />
                  Medical Insight
                </CNavLink>
              </CNavItem>
            </CHeaderNav>
            <CHeaderNav className="ms-auto me-4" style={{ fontSize: 12, cursor: 'pointer' }}>
              <CNavItem>
                <CNavLink href={() => false} onClick={(e) => { e.preventDefault(); followLink("/about"); }}>ABOUT US</CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href={() => false} onClick={(e) => { e.preventDefault(); followLink("/strategic-research"); }}>RESEARCH</CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href={() => false} onClick={(e) => { e.preventDefault(); followLink("/aesthetic-insights"); }}>AESTHETIC INSIGHTS</CNavLink>
              </CNavItem>
              <CNavItem>
                <CDropdown variant="nav-item" alignment="end">
                  <CDropdownToggle caret={true}>
                    INDUSTRY ASSOCIATION
                  </CDropdownToggle>
                  <CDropdownMenu className="pt-0" style={{ fontSize: 12 }}>
                    <CDropdownItem href={() => false} onClick={(e) => { e.preventDefault(); followLink("/aesthetic-industry-association"); }}>
                      THE AESTHETIC INDUSTRY ASSOCIATION
                    </CDropdownItem>
                    <CDropdownItem href={() => false} onClick={(e) => { e.preventDefault(); followLink("/aesthetic-industry-association#aia-board"); }}>
                      AIA ADVISORY BOARD
                    </CDropdownItem>
                    <CDropdownItem href={() => false} onClick={(e) => { e.preventDefault(); followLink("/aesthetic-industry-association#aia-awards"); }}>
                      AIA AWARDS
                    </CDropdownItem>
                    <CDropdownItem href={() => false} onClick={(e) => { e.preventDefault(); followLink("/aesthetic-industry-association#aia-sponsors"); }}>
                      AIA SPONSORS
                    </CDropdownItem>
                  </CDropdownMenu>
                </CDropdown>
              </CNavItem>
              <CNavItem>
                <CNavLink href={() => false} onClick={(e) => { e.preventDefault(); followLink("/beauty"); }}>THE BEAUTY SHOW</CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href={() => false} onClick={(e) => { e.preventDefault(); followLink("/ax-incubator"); }}>AX INCUBATOR</CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href={() => false} onClick={(e) => { e.preventDefault(); followLink("/gallery"); }}>GALLERY</CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href={() => false} onClick={(e) => { e.preventDefault(); followLink("/contact"); }}>CONTACT</CNavLink>
              </CNavItem>
              {/*
              <CNavItem>
                <CNavLink href="" onClick={(e) => { e.preventDefault();followLink("/login"); }}>ADMIN</CNavLink>
              </CNavItem>
              */}
              <CNavItem>
                <CNavLink href={() => false} onClick={(e) => { e.preventDefault(); followLink("/cart"); }}>CART</CNavLink>
              </CNavItem>
            </CHeaderNav>
          </CContainer>
        </CHeader>

        <Suspense fallback={<center style={{ paddingTop: 100 }}><CSpinner color="primary" /></center>}>
          <Routes>
            {siteRoutes.map((route, idx) => {
              return (
                route.component && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={<route.component />}
                  />
                )
              )
            })}
          </Routes>
        </Suspense>

        <footer id="Footer" style={styles.miFooter}>
          <div className="container">
            <div className="row">
              <div className="col-md">
                <a href="/">
                  <h6 style={styles.miFooterH6}>Medical Insight</h6>
                </a>
                <ul style={styles.miFooterUL}>
                  <li style={styles.miFooterLI}><a href={() => false} onClick={(e) => { e.preventDefault(); followLink("/about"); }} aria-current="page" className="active" style={styles.miFooterA}>About</a></li>
                  <li style={styles.miFooterLI}><a href={() => false} onClick={(e) => { e.preventDefault(); followLink("/strategic-research"); }} style={styles.miFooterA}>Strategic Research</a></li>
                  <li style={styles.miFooterLI}><a href={() => false} onClick={(e) => { e.preventDefault(); followLink("/aesthetic-insights"); }} style={styles.miFooterA}>Aesthetic Insights</a></li>
                  <li style={styles.miFooterLI}><a href={() => false} onClick={(e) => { e.preventDefault(); followLink("/gallery"); }} style={styles.miFooterA}>Gallery</a></li>
                  <li style={styles.miFooterLI}><a href={() => false} onClick={(e) => { e.preventDefault(); followLink("/contact"); }} style={styles.miFooterA}>Contact Us</a></li>
                </ul>
              </div>
              {/*
                <div className="col-md">
                    <a href="" onClick={(e) => { e.preventDefault();followLink("/aesthetic-accelerator")}>
                      <h6 style={styles.miFooterH6}>THE Aesthetic Accelerator</h6>
                    </a>
                </div>
                */}
              <div className="col-md">
                <a href={() => false} onClick={(e) => { e.preventDefault(); followLink("/aesthetic-industry-association"); }}>
                  <h6 style={styles.miFooterH6}>Aesthetic Industry Assoc.</h6>
                </a>
                <ul style={styles.miFooterUL}>
                  <li style={styles.miFooterLI}><a href={() => false} onClick={(e) => { e.preventDefault(); followLink("/aesthetic-industry-association#join"); }} style={styles.miFooterA}>Join Now</a></li>
                  <li style={styles.miFooterLI}><a href={() => false} onClick={(e) => { e.preventDefault(); followLink("/aesthetic-industry-association#aia-awards"); }} style={styles.miFooterA}>Awards</a></li>
                </ul>
              </div>
              <div className="col-md">
                {/*
                    <a href="/forum">
                      <h6 style={styles.miFooterH6}>The Aesthetic Forum</h6>
                    </a>
                    */}
                {/*
                    <ul style={styles.miFooterUL}>
                      <li style={styles.miFooterLI}><a href="" onClick={(e) => { e.preventDefault();followLink("/forum/faculty-bios")} style={styles.miFooterA}>Faculty Bios</a></li>
                      <li style={styles.miFooterLI}><a href="" onClick={(e) => { e.preventDefault();followLink("/forum/schedule")} style={styles.miFooterA}>Schedule</a></li>
                      <li style={styles.miFooterLI}><a href="" onClick={(e) => { e.preventDefault();followLink("/forum/registration")} style={styles.miFooterA}>Registration</a></li>
                    </ul>
                     */}
              </div>
              <div className="col-md-2 offset-md-1">
                <a href="https://www.linkedin.com/in/mimoretti/" target="_blank" rel="noopener noreferrer" className="mb-5" style={styles.miFooterA}>
                  <img src="https://miinews.com/static/core/graphics/LinkedInLogo-PNG_White.png" className="img-fluid mb-3" alt="LinkedIn" />
                </a>
                <a href="http://aesthetictv.com" target="_blank" rel="noopener noreferrer" className="mb-5" style={styles.miFooterA}>
                  <img src="https://miinews.com/static/core/graphics/ATVlogo2011_3D_outlines.svg" className="img-fluid mb-3" alt="ATV" />
                </a>
                <a href={() => false} onClick={(e) => { e.preventDefault(); followLink("/contact"); }} style={Object.assign({}, styles.miFooterA, { fontSize: '14px' })}>Contact Us</a></div>
            </div>
            <ul className="text-center mt-5 d-flex justify-content-center copyright" style={styles.miFooterUL}>
              <li style={Object.assign({}, styles.miFooterLI2, { borderRight: '1px solid #fff' })}><a href={() => false} onClick={(e) => { e.preventDefault(); followLink("/privacy-statement"); }} style={styles.miFooterA}>Privacy Statement</a></li>
              <li style={Object.assign({}, styles.miFooterLI2, { borderRight: '1px solid #fff' })}><a href={() => false} onClick={(e) => { e.preventDefault(); followLink("/terms-and-conditions"); }} style={styles.miFooterA}>Terms and Conditions</a></li>
              <li style={styles.miFooterLI2}>© Medical Insight Incorporated, All Rights Reserved.</li>
            </ul>
          </div>
        </footer>
      </div>
    </>
  )
}

export default SiteLayout
